<template>
    <div class="progress-bar">
        <span class="bar" :style="{ backgroundImage: gradientBar }"></span>
        <svg-sex data-cy="gender-icon" :class="['svg-icon', {'active': stepNo == 1 }]" :active="stepNo == 1"></svg-sex>
        <svg-location data-cy="location-icon" :class="['svg-icon', {'active': stepNo == 2 }]" :active="stepNo == 2"></svg-location>
        <svg-age-limit data-cy="age-limit-icon" :class="['svg-icon', {'active': stepNo == 3 }]" :active="stepNo == 3"></svg-age-limit>
        <svg-user data-cy="user-icon" :class="['svg-icon user-icon', {'active': stepNo == 4 }]" :active="stepNo == 4"></svg-user>
        <svg-mail data-cy="mail-icon" :class="['svg-icon mail-icon', {'active': stepNo == 5 }]" :active="stepNo == 5"></svg-mail>
    </div>
</template>

<script>
    import SvgSex from '@theme-views/common/SvgIcon/RegisterIcons/Sex'
    import SvgLocation from '@theme-views/common/SvgIcon/RegisterIcons/Location'
    import SvgAgeLimit from '@theme-views/common/SvgIcon/RegisterIcons/AgeLimit'
    import SvgUser from '@theme-views/common/SvgIcon/RegisterIcons/User'
    import SvgMail from '@theme-views/common/SvgIcon/RegisterIcons/Mail'
    import PRegisterCard from '@views/public/partials/PRegisterCard/p_register_card'

    export default {
        name: 'progress-bar',
        mixins: [PRegisterCard],
        components:{SvgSex,SvgLocation,SvgAgeLimit,SvgUser,SvgMail},
        props: {
            stepNo: {
                type: Number,
                default: 0
            }
        },
        computed: {
            gradientBar() {
                const percentage = ( this.stepNo * 100 ) / 5;
                return `linear-gradient(80deg, var(--sd-secondary-normal), #fff ${percentage}%)`
            }
        }
    }
</script>

<style lang="scss">
.progress-bar {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    > span.bar {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 4;
        width: 100%;
        background-image: linear-gradient(80deg, var(--sd-secondary-normal), #fff 20%);
        height: 4px;
    }
    .svg-icon {
        width: 40px;
        height: 40px;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0px 4px 15px rgba(28, 111, 157, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 5;
        &.active {
            background-image: linear-gradient(-80deg, var(--sd-secondary-normal), var(--sd-secondary-complement));
        }
    }
    @media(max-width: 1199px) {
        .svg-icon {
            width: 34px;
            height: 34px;
            > svg {
                width: 18px;
                height: 18px;
            }
        }
    }
}
</style>